import { useCallback, useEffect, useState } from 'react'

interface DropZoneProps {
  children: React.ReactNode
  onFileDrop: (event: Event) => void
}

const DragBox: React.FC<{
  children: React.ReactNode
  className?: string
  isVisible?: boolean
  onDragLeave?: (e: React.DragEvent<HTMLDivElement>) => void
}> = ({ children, className, isVisible, onDragLeave }) => (
  <div
    className={`drag-box ${className || ''}`}
    style={{ display: isVisible ? 'block' : 'none' }}
    onDragLeave={onDragLeave}
  >
    {children}
  </div>
)

const DropZone: React.FC<DropZoneProps> = ({ children, onFileDrop }) => {
  const [isVisible, setIsVisible] = useState(false)

  const onDragEnter = useCallback((e: Event) => {
    setIsVisible(true)
    e.stopPropagation()
    e.preventDefault()
    return false
  }, [])
  const onDragOver = useCallback((e: Event) => {
    e.preventDefault()
    e.stopPropagation()
    return false
  }, [])
  const onDragLeave = useCallback((e: React.DragEvent<HTMLDivElement>) => {
    setIsVisible(false)
    e.stopPropagation()
    e.preventDefault()
    return false
  }, [])
  const onDrop = useCallback(
    (e: Event) => {
      e.preventDefault()
      //const files = e.dataTransfer.files;
      onFileDrop(e)
      // Upload files
      setIsVisible(false)
      return false
    },
    [onFileDrop]
  )

  useEffect(() => {
    window.addEventListener('mouseup', onDragLeave as any)
    window.addEventListener('dragenter', onDragEnter)
    window.addEventListener('dragover', onDragOver)
    window.addEventListener('drop', onDrop)
    return () => {
      window.removeEventListener('mouseup', onDragLeave as any)
      window.removeEventListener('dragenter', onDragEnter)
      window.removeEventListener('dragover', onDragOver)
      window.removeEventListener('drop', onDrop)
    }
  }, [onDragEnter, onDragLeave, onDragOver, onDrop])

  return (
    <div>
      {children}
      <DragBox
        className='bg-secondary'
        isVisible={isVisible}
        onDragLeave={onDragLeave}
      >
        Drop files to Upload
      </DragBox>
    </div>
  )
}

export default DropZone
